const basePath = window.location.origin + process.env.PUBLIC_URL;

export const Globals = {
    window: () => window,
    navigator: () => navigator,
    document: (): Document => document,
    newImage: () => new Image(),
    timestamp: () => Date.now(),
    basePath,
    hostname: () => window.location.hostname,
};
